import { render, staticRenderFns } from "./elementCountrySwitcher.vue?vue&type=template&id=0530ec88"
import script from "./elementCountrySwitcher.vue?vue&type=script&lang=ts"
export * from "./elementCountrySwitcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports